$(document).ready(function() { 
 if ($(".product__info-wrapper").length > 0 ){
  $(document).scroll(function () {
    var w = $(window);
    var offset = $(".product__info-wrapper .product-form__buttons").offset();
    var btnheight = parseFloat(offset.top-w.scrollTop());
    if (btnheight <= 0){
      $('.product_bottom_fixed').fadeIn();
      $('.product_bottom_fixed').addClass('active');
    }
    else
    {
      $('.product_bottom_fixed').fadeOut();
      $('.product_bottom_fixed').removeClass('active');
    }
  });
}


  $(document).on('change', '.custom_select .select__select', function() {debugger;
    var selected_val = $(this).val();
// var selected_val1 = [];
//     $(this).parents('.custom_select').find('.product-form__input').each(function(){
//     console.log($(this).find('.select select :selected'));
//       var select_va = $(this).find('.select select :selected').val();
//       selected_val1.push(select_va);
//     });
//               console.log(selected_val1);
    $(".var-input-value[value = "+ selected_val +" ]").click();
     var c_price = $('.custom_price').find('s.price-item--regular').text().trim();
     var s_price = $('.custom_price').find('.price-item--sale').text().trim();
      $('.sticky-ptice').find('s.price-item--regular').text(c_price);
      $('.sticky-ptice').find('.price-item--sale').text(s_price);

    $('.compare_btn').find('.price').text(c_price);
    $('.compare_btn').find('s').text(s_price);
                                                                         
});
  $('.product-form__submit').click(function(){
    $('.no-submit').trigger('click');
  });

  var btn_price = $('.custom_price').find('.price-item--sale').text().trim();
  var c_price = $('.custom_price').find('s.price-item--regular').text().trim();
  $('.compare_btn').find('.price').text(btn_price);
  $('.compare_btn').find('s').text(c_price);

  // 28/10
var slider_count_val = $('.slider-buttons').find('.slider-counter--current').text();
$('.dots_option .dots').each(function(e){
    var active_val1 = $(this).attr('id');
    if(slider_count_val === active_val1){
        $(this).addClass('active');
    }
});
ul.addEventListener('scroll', event => {
var slider_count = $('.dots_option').attr('data_activeid');
$('.dots_option .dots').each(function(e){
    var active_val = $(this).attr('id');
$(this).removeClass('active');
    if(slider_count === active_val){
        $(this).addClass('active');
    }
});
});
});